// @ts-check
import Icon from 'components/base/Icon';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { LBButton } from '@linearb/buzz';

const FilterSetTitle = ({ filterSet, isCollapsed, toggleCollapse }) => {
  const isProject = filterSet?.type === SAVED_FILTER_SET_TYPES.PROJECT;
  return (
    <LBButton variant='ghost' size='sm' onClick={toggleCollapse}>
      <Icon name={isProject ? 'projects' : 'filter'} />
      {filterSet.name}

      <Icon
        name='ChevronRight'
        size='large'
        direction={isCollapsed ? 'left' : 'right'}
      />
    </LBButton>
  );
};

export default FilterSetTitle;
